const API_URL = "https://servicodados.ibge.gov.br/api/v1";
const LOCATIONS_URL = API_URL + "/localidades";

async function getStates() {
  let res = await fetch(`${LOCATIONS_URL}/estados`);
  return await res.json();
}

async function getCities(stateID) {
  let res = await fetch(`${LOCATIONS_URL}/estados/${stateID}/municipios`);
  return await res.json();
}

export default {
  getStates,
  getCities
};



// WEBPACK FOOTER //
// ./src/api/outers/IBGE.js